import React, { useState, useEffect, useCallback } from "react";
import { useLoading } from "../../../context/LoadingContext";
import {
  fetchData,
  postQuery,
} from "../../Requirement/services/RequirementServices";
import "../../../styles/general.css";
import "../../../styles/amtpl.css";
import { WidthFull } from "@mui/icons-material";
import AlertModal from "../../Requirement/components/common/AlerModel";
const CreateOffers = () => {
  const { setLoading } = useLoading();
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });



  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };
  // State for form data
  const [formData, setFormData] = useState({
    product: "",
    grade: "",
    minQuantity: "",
    basePrice: "",
    country: "India",
    state: "",
  });

  // State for product and grade data
  const [products, setProducts] = useState([]);
  const [availableGrades, setAvailableGrades] = useState([]);
  const [states, setStates] = useState([]);

  // State for quantity-price combinations
  const [combinations, setCombinations] = useState([
    { id: 1, additionalQty: "", priceReduction: "" },
  ]);

  // Fetch Products
  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const result = await fetchData({
        target: "listProducts",
        userOrder: "ProductName",
        rowStart: 0,
        pageSize: 500,
        filterTerms: { Status: "ACTIVE" },
      });

      if (result && result.products) {
        setProducts(result.products);
      } else if (result && result.items) {
        setProducts(result.items);
      } else {
        console.error(
          "Error fetching products: Invalid response format",
          result
        );
        setProducts([]);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  // Fetch States
  const fetchStates = useCallback(async () => {
    try {
      const body = {
        target: "listDropDownOptions",
        filterTerms: { Type: "State", Subtype: "India" },
        rowStart: 0,
        pageSize: 1000,
      };

      const result = await fetchData(body);
      if (result) {
        const stateOptions = result.items || [];
        setStates(stateOptions.map((state) => state.Value));
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  }, []);

  // Update available grades when product changes
  useEffect(() => {
    if (formData.product) {
      const filteredGrades = products
        .filter((product) => product.ProductName === formData.product)
        .map((product) => product.Grade)
        .filter((grade, index, self) => self.indexOf(grade) === index); // Remove duplicates
      setAvailableGrades(filteredGrades);
    } else {
      setAvailableGrades([]);
    }
  }, [formData.product, products]);

  // Load products and states on component mount
  useEffect(() => {
    fetchProducts();
    fetchStates();
  }, [fetchProducts, fetchStates]);

  // Handle form field changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      // Reset grade when product changes
      ...(name === "product" && { grade: "" }),
    }));
  };

  // Handle combination field changes
  const handleCombinationChange = (id, field, value) => {
    setCombinations((prev) =>
      prev.map((combo) =>
        combo.id === id ? { ...combo, [field]: value } : combo
      )
    );
  };

  // Add new combination
  const addCombination = () => {
    const newId = Math.max(...combinations.map((c) => c.id)) + 1;
    setCombinations((prev) => [
      ...prev,
      { id: newId, additionalQty: "", priceReduction: "" },
    ]);
  };

  // Remove combination
  const removeCombination = (id) => {
    if (combinations.length > 1) {
      setCombinations((prev) => prev.filter((combo) => combo.id !== id));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    if (
      !formData.product ||
      !formData.grade ||
      !formData.minQuantity ||
      !formData.basePrice ||
      !formData.country ||
      !formData.state
    ) {
      // alert("Please fill in all required fields");
      // return;
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Please fill in all required fields`,
      });
    }

    // Validate combinations
    const invalidCombinations = combinations.filter(
      (combo) =>
        !combo.additionalQty ||
        !combo.priceReduction ||
        parseFloat(combo.additionalQty) < 1
    );

    if (invalidCombinations.length > 0) {
      // alert(
      //   "Please fill in all quantity multiplier and price reduction fields. Multiplier must be at least 1."
      // );
      // return;
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Please fill in all quantity multiplier and price reduction fields. Multiplier must be at least 1.`,
      });
    }

    // Get product ID using combination of product name and grade
    const selectedProduct = products.find(
      (p) => p.ProductName === formData.product && p.Grade === formData.grade
    );
    const productId = selectedProduct ? selectedProduct.ProductID : null;

    if (!productId) {
      // alert(
      //   "Product ID not found for the selected product and grade combination"
      // );
      // return;
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Please fill in all quantity multiplier and price reduction fields. Multiplier must be at least 1.`,
      });
    }

    // Create array with minimum quantity as first element, then additional tiers
    const selectedPrice = [];

    // First element: minimum quantity with base price
    selectedPrice.push({
      quantity: parseFloat(formData.minQuantity),
      pricePerMT: parseFloat(formData.basePrice),
      productID: productId,
      originCountry: formData.country,
      State: formData.state,
    });

    // Additional tiers with price reductions
    combinations.forEach((combo) => {
      const totalQuantity =
        parseFloat(formData.minQuantity) * parseFloat(combo.additionalQty);
      const discountedPrice =
        parseFloat(formData.basePrice) *
        (1 - parseFloat(combo.priceReduction) / 100);

      selectedPrice.push({
        quantity: totalQuantity,
        pricePerMT: discountedPrice,
        productID: productId,
        originCountry: formData.country,
        State: formData.state,
      });
    });

    try {
      setLoading(true);

      const body = {
        target: "generateAutomaticOffers",
        product: productId,
        selectedPrice: selectedPrice,
      };

      const result = await postQuery(body);
      console.log(
        "Offer creation response:",
        result,
        result.items,
        result.items?.success
      );

      if (result && result.items?.success === true) {
        // alert(
        //   result.items?.message +
        //     (result.items?.itemsProcessed
        //       ? ". Offers created: " + result.items?.itemsProcessed
        //       : "")
        // );
        setModal({
          show: true,
          type: "success",
          title: "Success",
          message: `${result.items?.message || ""}${result.items?.itemsProcessed
              ? `. Offers created: ${result.items?.itemsProcessed}`
              : ""
            }`,
          autoClose: false,
        });

        handleReset(); // Reset form after successful creation
      } else {
        console.error("Error creating offer:", result);
        //alert("Error creating offer. Please try again.");
        setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Error creating offer. Please try again.`,
      });
      }
    } catch (error) {
      console.error("Error creating offer:", error);
      //alert("Error creating offer. Please try again.");
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Error creating offer. Please try again.`,
      });
    } finally {
      setLoading(false);
    }
  };

  // Reset form
  const handleReset = () => {
    setFormData({
      product: "",
      grade: "",
      minQuantity: "",
      basePrice: "",
      country: "India",
      state: "",
    });
    setCombinations([{ id: 1, additionalQty: "", priceReduction: "" }]);
  };

  return (
    <div className="buyer-dashboard card">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <h2 className="mb-2">Create New Offer</h2>

            <form onSubmit={handleSubmit} className="card p-4">
              {/* Basic Offer Information */}
              <div className="mb-4">
                <h4 className="mb-3">Basic Offer Information</h4>
                <div className="row">
                  <div className="col-lg-3 col-md-6 mb-3">
                    <label htmlFor="product" className="form-label">
                      Product <span className="text-danger">*</span>
                    </label>
                    <select
                      id="product"
                      name="product"
                      className="form-select"
                      value={formData.product}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select a product</option>
                      {[
                        ...new Set(
                          products.map((product) => product.ProductName)
                        ),
                      ].map((productName) => (
                        <option key={productName} value={productName}>
                          {productName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-3 col-md-6 mb-3">
                    <label htmlFor="grade" className="form-label">
                      Grade <span className="text-danger">*</span>
                    </label>
                    <select
                      id="grade"
                      name="grade"
                      className="form-select"
                      value={formData.grade}
                      onChange={handleInputChange}
                      disabled={!formData.product}
                      required
                    >
                      <option value="">Select a grade</option>
                      {availableGrades.map((grade) => (
                        <option key={grade} value={grade}>
                          {grade}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-3 col-md-6 mb-3">
                    <label htmlFor="country" className="form-label">
                      Country <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="country"
                      name="country"
                      className="form-control"
                      value={formData.country}
                      readOnly
                      required
                    />
                  </div>

                  <div className="col-lg-3 col-md-6 mb-3">
                    <label htmlFor="state" className="form-label">
                      State <span className="text-danger">*</span>
                    </label>
                    <select
                      id="state"
                      name="state"
                      className="form-select"
                      value={formData.state}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select a state</option>
                      {states.map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-3 col-md-6 mb-3">
                    <label htmlFor="minQuantity" className="form-label">
                      Minimum Quantity (MT){" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      id="minQuantity"
                      name="minQuantity"
                      className="form-control"
                      value={formData.minQuantity}
                      onChange={handleInputChange}
                      min="0"
                      step="0.01"
                      placeholder="Enter minimum quantity"
                      required
                    />
                  </div>

                  <div className="col-lg-3 col-md-6 mb-3">
                    <label htmlFor="basePrice" className="form-label">
                      Base Price (₹/MT) <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      id="basePrice"
                      name="basePrice"
                      className="form-control"
                      value={formData.basePrice}
                      onChange={handleInputChange}
                      min="0"
                      step="0.01"
                      placeholder="Enter base price"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Pricing Tiers */}
              <div className="mb-4">
                <div className="d-flex  align-items-center mb-3">
                  <h4>Quantity-Based Pricing Tiers</h4>
                  <button
                    type="button"
                    className="submit-btn-more"
                    onClick={addCombination}
                    style={{ width: '150px', marginLeft: '10px' }}
                  >
                    + Add Tier
                  </button>
                </div>
                <div className="alert alert-info">
                  <small>
                    <strong>Note:</strong> Enter a multiplier for total
                    quantity. For example, if minimum quantity is 50 MT and you
                    enter multiplier 5, the total quantity will be 250 MT (5 ×
                    50).
                  </small>
                </div>

                {combinations.map((combination, index) => (
                  <div key={combination.id} className="card border-light mb-3">
                    <div className="card-body">
                      <div className="d-flex  align-items-center mb-2">
                        <h6 className="card-title mb-0">Tier {index + 1}</h6>
                        {combinations.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => removeCombination(combination.id)}
                            style={{ width: '150px', marginLeft: '10px' }}
                          >
                            Remove
                          </button>
                        )}
                      </div>

                      <div className="row">
                        <div className="col-lg-4 col-md-6 mb-3">
                          <label className="form-label">
                            Quantity Multiplier{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={combination.additionalQty}
                            onChange={(e) =>
                              handleCombinationChange(
                                combination.id,
                                "additionalQty",
                                e.target.value
                              )
                            }
                            min="1"
                            step="1"
                            placeholder="Enter multiplier (e.g., 5 for 5x min qty)"
                            required
                          />
                          {formData.minQuantity &&
                            combination.additionalQty && (
                              <div className="form-text text-muted">
                                Total Quantity:{" "}
                                {(
                                  parseFloat(formData.minQuantity) *
                                  parseFloat(combination.additionalQty)
                                ).toFixed(2)}{" "}
                                MT
                              </div>
                            )}
                        </div>

                        <div className="col-lg-4 col-md-6 mb-3">
                          <label className="form-label">
                            Price Reduction (%){" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={combination.priceReduction}
                            onChange={(e) =>
                              handleCombinationChange(
                                combination.id,
                                "priceReduction",
                                e.target.value
                              )
                            }
                            min="0"
                            max="100"
                            step="0.01"
                            placeholder="Discount percentage"
                            required
                          />
                        </div>

                        <div className="col-lg-4 col-md-12 mb-3">
                          <label className="form-label">Tier Summary</label>
                          <div className="form-control-plaintext">
                            {formData.minQuantity &&
                              combination.additionalQty &&
                              formData.basePrice &&
                              combination.priceReduction ? (
                              <>
                                <div>
                                  <strong>Total Qty:</strong>{" "}
                                  {(
                                    parseFloat(formData.minQuantity) *
                                    parseFloat(combination.additionalQty)
                                  ).toFixed(2)}{" "}
                                  MT
                                </div>
                                <div>
                                  <strong>Discounted Price:</strong> ₹
                                  {(
                                    parseFloat(formData.basePrice) *
                                    (1 -
                                      parseFloat(combination.priceReduction) /
                                      100)
                                  ).toFixed(2)}
                                  /MT
                                </div>
                              </>
                            ) : (
                              <div className="text-muted">
                                Fill in values to see summary
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Action Buttons */}
              <div className="d-flex gap-3">
                <button type="submit" className="submit-btn-more"
                  style={{ width: '150px' }}>
                  Create Offer
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{ width: '150px' }}
                  onClick={handleReset}
                >
                  Reset Form
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateOffers;
